import { s as t, _ as o } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as a, c as i } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var r = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M30.152 5.333H1.863C2.666 3.858 4.05 2.12 6.343 1.23 8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 2.275.884 3.655 2.602 4.461 4.07ZM1.863 26.667h28.274c-.804 1.475-2.188 3.213-4.48 4.103-2.09.83-5.907 1.197-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23-2.292-.89-3.676-2.628-4.479-4.103Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.66 21.333H.325a34.916 34.916 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316Z",
      clipRule: "evenodd"
    }
  )
), p = a(r)`
  ${t}
  ${i}
`, w = p;
export {
  w as default
};
